import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import "./styles.scss";

interface SmartButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    mode?: "primary" | "secondary" | "cancel";
    isLoading?: boolean;
    disabled?: boolean;
}

const SmartButton = (props: SmartButtonProps): JSX.Element => {
    const { isLoading, disabled, ...restOfProps } = props;

    return (
        <button
            className={classNames({
                "smart-button": true,
                secondary: props.mode === "secondary",
                cancel: props.mode === "cancel"
            })}
            {...restOfProps}
            disabled={isLoading || disabled}
        >
            {isLoading ? "Loading..." : props.children}
        </button>
    );
};

export default SmartButton;
